<a href="#" style="display: none"></a>

<div class="modal-header">
    <h4 class="modal-title">
        {{(!canEdit ? 'studentCourseEqualization_viewCourseTitle' : model.Id ? 'studentCourseEqualization_editCourseTitle' : 'studentCourseEqualization_addCourseTitle') | translate}}
    </h4>
</div>

<div class="modal-body">
    <form #form="ngForm">
        <div class="form-field">
            <label class="form-label">
                {{'studentCourseEqualization_lblInnerCourse' | translate}}
                <span class="required-mark"></span>
                <span [ngbTooltip]="'studentCourseEqualization_hintInnerCourse' | translate" class="fi fi-rs-interrogation ms-1"></span>
            </label>
            <app-select [(ngModel)]="innerCourse"
                        [options]="innerCourseOptions"
                        [displayFn]="courseDisplayFn"
                        [required]="true"
                        [disabled]="!canEdit"
                        name="innerCourse"
                        [filter]="courseFilterFn">
            </app-select>
        </div>

        <p class="text-top">
            {{'studentCourseEqualization_prevCompletedCourseInfo' | translate}}
        </p>

        <div class="form-field">
            <label class="form-label">
                {{'studentCourseEqualization_lblPrevCompletedCourse' | translate}}
                <span class="required-mark"></span>
                <span [ngbTooltip]="'studentCourseEqualization_hintCourseType' | translate" class="fi fi-rs-interrogation ms-1"></span>
            </label>
            <app-select [(ngModel)]="type"
                        [options]="typeOptions"
                        [displayProperty]="'Value'"
                        [required]="true"
                        [disabled]="!canEdit"
                        (selectionChange)="onTypeChange($event)"
                        name="type">
            </app-select>
        </div>

        <div class="form-field required" *ngIf="universityVisible">
            <label class="form-label">{{'studentCourseEqualization_lblUniversity' | translate}}</label>
            <input class="form-control" required [(ngModel)]="model.University" name="university" [disabled]="!canEdit" />
        </div>

        <div class="form-field required" *ngIf="programmeVisible">
            <label class="form-label">{{'studentCourseEqualization_lblProgrammeName' | translate}}</label>
            <input class="form-control" required [(ngModel)]="model.Programme" name="programme" [disabled]="!canEdit" />
        </div>

        <div class="form-field">
            <label class="form-label">
                {{'studentCourseEqualization_lblPrevCompletedCourseName' | translate}}
                <span class="required-mark"></span>
                <span [ngbTooltip]="'studentCourseEqualization_hintCourseName' | translate" class="fi fi-rs-interrogation ms-1"></span>
            </label>
            <input class="form-control" required [(ngModel)]="model.Name" name="name" [disabled]="!canEdit" />
        </div>

        <div class="form-field" *ngIf="notesVisible">
            <label class="form-label">{{'studentCourseEqualization_lblNotes' | translate}}</label>
            <textarea class="form-control" [(ngModel)]="model.Notes" rows="5" name="notes" [disabled]="!canEdit"></textarea>
        </div>

        <div class="row">
            <div class="form-field col-sm">
                <label class="form-label">
                    {{'studentCourseEqualization_lblPrevCompletedCourseEcts' | translate}}
                    <span class="required-mark"></span>
                    <span [ngbTooltip]="'studentCourseEqualization_hintEcts' | translate" class="fi fi-rs-interrogation ms-1"></span>
                </label>
                <input class="form-control" [(ngModel)]="model.Ects" name="ects" required [pattern]="pointValidationPattern" [disabled]="!canEdit" />
            </div>

            <div class="form-field col-sm">
                <label class="form-label">
                    {{'studentCourseEqualization_lblPrevCompletedCourseGrade' | translate}}
                    <span class="required-mark"></span>
                    <span [ngbTooltip]="'studentCourseEqualization_hintGrade' | translate" class="fi fi-rs-interrogation ms-1"></span>
                </label>
                <app-select [(ngModel)]="model.GradeId"
                            [options]="gradeOptions"
                            [valueProperty]="'Id'"
                            [displayProperty]="'Value'"
                            [disabled]="!canEdit"
                            [required]="true"
                            name="theory">
                </app-select>
            </div>
        </div>

        <div class="form-field">
            <label class="form-label">
                {{'studentCourseEqualization_lblSupportingDocuments' | translate}}
                <span class="required-mark"></span>
                <span [ngbTooltip]="'studentCourseEqualization_hintAttachments' | translate" class="fi fi-rs-interrogation ms-1"></span>
            </label>

            <div *ngFor="let a of model.Attachments; let i = index" class="d-flex mb-2">
                <div class="flex-grow-1">
                    <app-file [(ngModel)]="a.File"
                              [accept]="attachmentExtensions"
                              [maxSize]="attachmentMaxSize"
                              name="attachment{{i}}"
                              [immediate]="!a.Id && !a.File && !a.FileName"
                              [disabled]="!canEdit && a.Id"
                              (fileChange)="onFileChange($event, a)"
                              #attachmentInput="ngModel"></app-file>
                    <div class="invalid-feedback" *ngIf="!a.FileName">{{'studentCourseEqualization_emptyAttachment' | translate}}</div>
                    <div class="invalid-feedback" *ngIf="checkDuplicateFileName(a)">{{'studentCourseEqualization_duplicateFileName' | translate}}</div>
                </div>

                <button class="btn btn-outline btn-icon align-self-end ms-3" *ngIf="a.Id"
                        (click)="downloadAttachment(a)" [ngbTooltip]="'download' | translate">
                    <i class="fi fi-rs-download"></i>
                </button>
            </div>

            <div *ngIf="canEdit">
                <button class="btn btn-tertiary" type="button" (click)="addAttachment()">
                    <i class="fi fi-rs-plus"></i>
                    {{'studentCourseEqualization_btnAddSupportingDocument' | translate}}
                </button>
            </div>

            <div class="invalid-feedback" *ngIf="model.Attachments.length < 1">{{'studentCourseEqualization_supportingDocumentRequired' | translate}}</div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="cancel()">
        {{(!canEdit ? 'dialog_close' : 'dialog_cancel') | translate}}
    </button>

    <button class="btn btn-primary" type="button" (click)="ok()" [disabled]="!isValid" *ngIf="canEdit">
        {{'dialog_ok' | translate}}
    </button>
</div>
